"use client"

import { AnimatePresence, motion } from "motion/react"
import { useEffect, useState } from "react"
import { useTextWidth } from "./useTextWidth"

const words = [
  "Photographer",
  "Stylist",
  "Videographer",
  "Hair & Makeup Artist",
  "Graphic Designer",
  "Director",
  "Editor",
]

const cycleInterval = 2500 // 3 seconds

export function WordCycler() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const currentWord = words[currentIndex]
  const { width, ref } = useTextWidth(currentWord)

  useEffect(() => {
    setIsFirstRender(false)

    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % words.length)
    }, cycleInterval)

    return () => clearInterval(timer)
  }, [])

  return (
    <motion.div
      animate={{ width: width }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      className="overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.span
          key={currentWord}
          initial={isFirstRender ? { opacity: 1 } : { opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="inline-block shrink-0 whitespace-nowrap text-nowrap"
          aria-live="polite">
          {currentWord}
        </motion.span>
      </AnimatePresence>
      <span
        ref={ref}
        className="pointer-events-none absolute inline-block shrink-0 whitespace-nowrap text-nowrap opacity-0">
        {currentWord}
      </span>
    </motion.div>
  )
}
